var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-bar"},_vm._l((_vm.list),function(t,i){return _c('div',{key:i,staticClass:"tab-item",class:{active: _vm.tab === i},on:{"click":function($event){return _vm.selectTab(i)}}},[(_vm.$scopedSlots.tab)?_vm._t("tab",null,{"tab":t}):[_c('span',[_vm._v(_vm._s(t))])],_c('div',{staticClass:"tab-active"})],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }